import { Card, Layout, Typography } from 'antd';
import { PrdispatchForm } from './PrdispatchForm';

export const PrdispatchPage = () => {
  return (
    <Layout style={{ minHeight: '100vh', padding: 24 }}>
      <Layout.Content style={{ maxWidth: 720, margin: '0 auto', width: '100%' }}>
        <Typography.Title level={2}>Pull Guardian — Dispatch</Typography.Title>
        <Typography.Paragraph>
          Submit a task for the automated PR pipeline.
        </Typography.Paragraph>
        <Card>
          <PrdispatchForm />
        </Card>
      </Layout.Content>
    </Layout>
  );
};
